import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import BaseAnchor from "../Anchor/BaseAnchor";
import { IconChevronLeft16 } from "../Icons/Icons";

const VerticalNavSubLevelContainer = ({
  parentSectionName,
  parentUrl,
  onClick,
  children,
  isActiveSection,
  id,
}) => {
  const classes = classNames("vertical-nav__sub-block", {
    "is-active": isActiveSection,
  });

  return (
    <div className={classes} id={id}>
      <div className="vertical-nav__sub-block-inner">
        <div className="vertical-nav__back-btn-container">
          <BaseAnchor
            className="vertical-nav__back-btn"
            to={parentUrl}
            onClick={onClick}
            title={`Go back to ${parentSectionName}`}
          >
            <IconChevronLeft16 className="vertical-nav__arrow-icon" />
            Back to {parentSectionName}
          </BaseAnchor>
        </div>
        <ul className="vertical-nav__list vertical-nav__list--sub-level" role="group">
          {children}
        </ul>
      </div>
    </div>
  );
};

VerticalNavSubLevelContainer.propTypes = {
  id: PropTypes.string.isRequired,
  parentSectionName: PropTypes.string.isRequired,
  parentUrl: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  isActiveSection: PropTypes.bool,
};

export default VerticalNavSubLevelContainer;
